<mat-toolbar fxLayoutAlign="space-between center" class="header">
  <img class="logo" src="assets/img/elab-logo-small.svg" />
  <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="center center">
    <div
      class="username-card"
      fxLayout="row"
      fxLayoutGap="8px"
      fxLayoutAlign="center center"
    >
      <mat-icon
        aria-hidden="false"
        aria-label=" home icon"
        fontIcon="account_circle"
        color="accent"
      ></mat-icon>
      <p class="text-user">
        Zdravo, <b>{{ username }}</b>
      </p>
    </div>
    <button
      mat-button
      mat-stroked-button
      color="accent"
      (click)="logout()"
      [ngStyle]="{
        padding: '0 16px',
        borderRadius: '8px',
        fontSize: '14px',
        letterSpacing: '0.8px',
        fontWeight: 'bold'
      }"
    >
      <mat-icon
        aria-hidden="false"
        aria-label=" logout icon"
        fontIcon="logout"
      ></mat-icon>
      Odjavi se
    </button>
  </div>
</mat-toolbar>
